<template lang="html">
  <div class="container">
      <div class="divider_line">
          <span>基本信息</span>
      </div>
      <div class="info-page">
          <div><i class="iconfont">&#xe6b9;</i>{{detail.full_name | empty('暂无信息')}}</div>
          <div><i class="iconfont">&#xe632;</i>{{detail.setup_time | timeTrans('暂无建院时间')}}</div>
          <div><i class="iconfont">&#xe64f;</i>{{detail.employee_id | deal('employee', 'employee', '暂无医院规模信息')}}</div>
          <div>
              <i class="iconfont">&#xe650;</i>
              <a :href="detail.main_page | page" target="_blank" v-if="detail.main_page">{{detail.main_page}}</a>
              <template v-else>暂无官网地址</template>
          </div>
          <div><i class="iconfont">&#xe638;</i>{{detail.email | empty('暂无电子邮箱')}}</div>
          <div><i class="iconfont">&#xe635;</i>{{detail.tel | empty('暂无联系电话')}}</div>
          <div><i class="iconfont">&#xe63a;</i>{{detail.address | empty('暂无医院地址')}}</div>
          <div><i class="iconfont">&#xe6cd;</i>{{detail.road_map | empty('暂无乘车路线')}}</div>
          <div>
              <i class="iconfont">&#xe6cc;</i>
              HIMSS Analytics EMRAM({{detail.himss_emram_level | deal('h_emr_level')}})、
              HIMSS Analytics O-EMRAM({{detail.himss_o_emram_level | deal('h_emr_level')}})、
              JCI认证({{detail.has_jci | isno('已认证','未认证')}})、星级医院({{detail.star_level | deal('star_level')}})、
              电子病历系统({{detail.emr_level | deal('h_emr_level')}})、
              互联互通标准化成熟度(<template v-if="detail.hlht_level1 && detail.hlht_level2">{{detail.hlht_level1 | deal('hlht_level1')}}{{detail.hlht_level2 | deal('hlht_level2')}}</template><template v-else>未评级</template>)
          </div>
      </div>
      <div class="description-page">
          <p>{{detail.description}}</p>
          <div class="other-info">
              <p>附加信息</p>
              <div class="info-li">
                  <div class="info-li-l">特色科室</div>
                  <div class="info-li-r">
                      <span class="span_tag" v-for="item,index in dep">{{item}}</span>
                  </div>
              </div>
              <div class="info-li">
                  <div class="info-li-l">设备</div>
                  <div class="info-li-r">
                      <span class="span_tag" v-for="item,index in machine">{{item}}</span>
                  </div>
              </div>
              <div class="info-li">
                  <div class="info-li-l">标签</div>
                  <div class="info-li-r">
                      <span class="span_tag" v-for="item,index in hos_tag">{{item.tag_id | deal('hospital_tag')}}</span>
                  </div>
              </div>
          </div>
      </div>
      <Spin fix v-if="spinShow">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
      </Spin>
  </div>
</template>

<script>
import { hospitalDetail } from '../../../service'
import filter from 'js/filter'
export default {
  inject: ['reload'],
  data(){
    return {
      spinShow: true,
      detail: '',
      hos_tag: []
    }
  },
  computed: {
    uid() {
      return this.$route.params.uid
    },
    dep() {
      if(this.detail.dep) {
        return this.detail.dep.split(',')
      }else {
        return []
      }
    },
    machine() {
      if(this.detail.machine) {
        return this.detail.machine.split(',')
      }else {
        return []
      }
    }
  },
  methods: {
    async getDetail() {
      let res = await hospitalDetail({uid: this.uid}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'detail', res.res)
        this.$set(this.$data, 'hos_tag', res.hos_tag)
        this.$emit('handleGetDetail', res.res)
      } else {
        this.$Message.error(res.msg)
      }
      this.spinShow = false
    }
  },
  created() {
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.container
  position: relative
  padding: 40px 32px 40px 32px
  .info-page
    padding: 38px 20px 30px 20px
    border-bottom: 1px dashed
    commonBorderColor(#40444F, #E9E9E9)
    > div
      font-size: 14px
      commonColor(#E9E9EB, #333333)
      padding-left: 28px
      position: relative
      line-height: 20px
      &+div
        margin-top: 14px
      i
        color: #999
        position: absolute
        top: 0
        left: 0
        font-size: 14px
      a
        color: rgba(250, 122, 80, 1)
        &:hover
          color: #FC9C7C
  .description-page
    padding: 30px 20px 0
    > p
      font-size: 14px
      commonColor(#E9E9EB, #333333)
      line-height: 22px
    .other-info
      padding-top: 30px
      > p
        font-size: 16px
        commonColor(#E9E9EB, #333333)
        padding-left: 16px
        position: relative
        &:before
          content: ''
          position: absolute
          width: 4px
          height: 16px
          background: rgba(250, 122, 80, 1)
          border-radius: 2px
          top: 0
          left: 0
      .info-li
        display: flex
        margin-top: 16px
        &-l
          flex: 0 0 72px
          font-size: 14px
          commonColor(#BCBDC1, #666666)
          line-height: 24px
        &-r
          flex: auto
          margin-bottom: -10px
          margin-right: -10px
        span
          margin-bottom: 10px
          margin-right: 10px
</style>
